import logo from "../images/safety-hero-logo.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { useGameStore } from "../store/gameStore";

const Home = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const { setUserName } = useGameStore();

  const handleStart = () => {
    if (name.trim() === "") {
      toast.error("이름을 입력해주세요.");
      return;
    }
    setUserName(name.trim());
    navigate("/how-to-play");
  };

  const handleRankingBoard = () => {
    navigate("/ranking-board");
  };

  return (
    <div className="flex flex-col justify-between">
      <header className="flex flex-col items-center justify-center pt-10 px-4">
        <div className="flex flex-col items-center space-y-8">
          <div className="pl-5 w-screen h-64 flex items-center justify-center">
            <img
              src={logo}
              alt="Safety Hero Logo"
              className="w-full h-full object-contain drop-shadow-2xl"
            />
          </div>
        </div>
      </header>

      <section className="flex flex-col items-center space-y-8 px-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center space-x-3 bg-white/95 backdrop-blur-sm rounded-xl border-2 border-blue-600 p-3">
            <label className="text-blue-600 font-bold text-lg px-2 whitespace-nowrap">
              이름
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder=""
              className="flex-1 py-2 text-lg text-gray-800 bg-transparent focus:outline-none"
            />
          </div>
        </div>

        <div className="flex flex-col space-y-8 w-full max-w-sm">
          {/* 시작하기 버튼 */}
          <button
            className="w-full px-8 py-5 bg-gradient-to-b from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white text-xl font-bold rounded-xl shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95 flex items-center justify-center space-x-3"
            onClick={handleStart}
          >
            <span className="text-2xl">🚀</span>
            <span>시작하기</span>
          </button>

          {/* 순위표 버튼 */}
          <button
            onClick={handleRankingBoard}
            className="w-full px-8 py-5 bg-gradient-to-b from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-xl font-bold rounded-xl shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95 flex items-center justify-center space-x-3"
          >
            <span className="text-2xl">🏆</span>
            <span>순위표</span>
          </button>
        </div>
      </section>

      <footer className="flex flex-col items-center justify-center pt-28 px-4">
        <p className="text-sm text-gray-900 font-semibold">
          Copyright © 2025 Cremond, Inc. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Home;